// /Users/baladharshan/Letstream/Master frontend/frontend/src/app/core/store/auth/auth.effects.ts

import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {login, loginFailure, loginSuccess} from './auth.actions';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {AuthService} from '@app/public/auth/service/auth.service';

@Injectable()

export class AuthEffects {

    private authService = inject(AuthService);
    private actions$ = inject(Actions);

    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(login),
            mergeMap(action =>
                this.authService.login(action.credentials).pipe(
                    map(response => response!.data!.login),
                    map(({
                        auth: { token, refreshToken: refreshToken },
                        user
                    }) => loginSuccess({ token, refreshToken, user })),
                    catchError(error => of(loginFailure({ error: error.message })))
                )
            )
        )
    );
}
